import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useApiClient, useFetchImmutable } from '@marageti/z4-lib';
import { TimeZoneMap } from '@marageti/z4-sdk/lib/standards';
import { Traveler } from '@marageti/z4-sdk/lib/people';
import { FieldValues } from 'react-hook-form';
import { useAuthStore } from '../../../store';
import LoginLayout from '../../login/login-layout';
import { ConfirmPhoneView } from '../../login/steps/confirm-phone';
import TripRequestConfirmationView from './trip-request-confirmation-view';

const DEFAULT_VALUES = {
  phone: {
    prefix: '',
    number: '',
  },
  timeZone: {
    name: '',
    rawOffsetInMinutes: 0,
  },
};

const TripRequestConfirmationContainer = () => {
  const {
    loggedInTraveler,
    setIsAuthenticated,
    setAuthenticatedTraveler,
  } = useAuthStore();
  const apiClient = useApiClient();

  const [params] = useSearchParams();
  const navigate = useNavigate();
  const tripRequestId = params.get('tripRequestId');
  const [showConfirmPhone, setShowConfirmPhone] = useState(true);
  const tripRequestDestination = tripRequestId ? `/trip-requests/${tripRequestId}` : undefined;

  const timezones = useFetchImmutable<TimeZoneMap>(apiClient.standardsClient.getTimeZones, [], true);
  const timezonesMap = timezones.data ? new Map(Object.entries(timezones.data)) : new Map();
  const suggestedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone.replace(/_/g, ' ');
  const suggestedTimezoneOption = timezonesMap.has(suggestedTimezone) ? {
    name: suggestedTimezone,
    rawOffsetInMinutes: timezonesMap.get(suggestedTimezone),
  }
    : DEFAULT_VALUES.timeZone;

  const handleViewClick = () => {
    setIsAuthenticated(true);
    navigate(tripRequestDestination || '/');
  };

  const onPhoneSubmit = async (data: FieldValues) => {
    if (loggedInTraveler) {
      const { phone, timeZone } = data;
      const request = {
        ...loggedInTraveler,
        ...(phone.number && { phone: data.phone }),
        ...(timeZone.name && { timeZone: data.timeZone }),
      };
      try {
        const res: Traveler = await apiClient.peopleClient.putTraveler(loggedInTraveler.id, request);
        setAuthenticatedTraveler(res);
      } catch (error) {
        console.error('Failed to submit phone:', error);
      } finally {
        setShowConfirmPhone(false);
      }
    }
  };

  if (showConfirmPhone) {
    return (
      <LoginLayout>
        <ConfirmPhoneView
          defaultValues={{
            phone: loggedInTraveler?.phone || DEFAULT_VALUES.phone,
            timeZone: loggedInTraveler?.timeZone.name
              ? loggedInTraveler?.timeZone
              : suggestedTimezoneOption,
          }}
          onSubmit={onPhoneSubmit}
        />
      </LoginLayout>
    );
  }

  return (
    <LoginLayout>
      <TripRequestConfirmationView
        handleViewClick={handleViewClick}
        isViewButtonDisabled={!tripRequestId}
      />
    </LoginLayout>
  );
};

export default TripRequestConfirmationContainer;
